import { createSelector } from 'reselect'

const flocabularySelector = state => state.flocabulary

const saveSelector = videoId => createSelector(
	[flocabularySelector],
	flocabulary => {
		const video = flocabulary.videos.find(video => video.contentId === videoId)
		const data_all = {
			videoId,
			category: flocabulary.category,
		}

		return {
			saveData: {
				data_all,
				title: video.title,
				completed: 1,
			},
			entityUID: flocabulary.entityUID,
		}
	}
)

export default saveSelector
